import React, { useState , useEffect } from "react";
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import {db} from './../../config/firebaseConfig';
import {Link} from 'react-router-dom';
import toSlugCase from 'to-slug-case';
import { format } from 'date-fns';
import { client } from './../../contentful/contentful';


const Blog = () => {

  const [subcribeEmail,SetSubscribeEmial] = useState('');
  const [disableBtn,setDisableBtn] = useState(false);
  const [emailSubmitted,setEmailSubmitted] = useState(false);
  const [validationErrorMessage,setValidationErrorMessage] = useState("");
  const [post , setPost ] = useState({}); 
  const [posts , setPosts ] = useState([]);
  const [loading,setLoading] = useState(false);
  

  useEffect( ()=>{
    try {
      setLoading(true);
      let getEntryIDFromURL = window.location.href.split('/');
      client.getEntries({
        'content_type': 'blogPost'
      }).then( response =>{
          let items = response.items;
          const entries = items.filter( post => post.sys.id === getEntryIDFromURL[6] );
          if(entries.length === 0){
            setPost({});
          }else{
            setPost(entries[0]);
          }
          setLoading(false);
          setPosts([items[0],items[1],items[2]]);
      });
      window.scrollTo(0, 0);
    } catch (error) {
      console.log('error obteniendo posts ' + error);
    }
  },[] );


  const saveEmail = async () =>{
    if(!(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/.test(subcribeEmail))){
      setValidationErrorMessage("Error: Debe ingresar un email válido");
      setDisableBtn(false);
      return false;
    }
    setValidationErrorMessage("");
    await db.collection('newsletter-sign-ups').doc().set({
      email : subcribeEmail
    }).then(response =>{
      setDisableBtn(false);
      setEmailSubmitted(true);
      SetSubscribeEmial("");
      setTimeout( ()=>{
        setEmailSubmitted(false);
      },3000);
    });
  }

  const handleSubcribe = (e) =>{
    try {
      e.preventDefault();
      setDisableBtn(true);
      saveEmail();
    } catch (error) {
      console.log('Error al enviar correo' + error );
    }
  }

  const set_post_redux = (date,title,id) =>{
      let indexOfBlog = window.location.href.indexOf('/blog');
      const subStringWithoutBlog = window.location.href.substring(0,indexOfBlog);
      let finalURL = subStringWithoutBlog.concat(`/blog/${toSlugCase(format( new Date(date),'yy MM'))}/${toSlugCase(title)}/${id}`);
      window.location.replace(finalURL);
  }

  return ( 
    <React.Fragment>
      <div className="module ptb-100">
      {
        loading ?
        <div className="container">
          <div className="row">
            <div className="col d-flex justify-content-center my-5">
              <div class="spinner-border text-danger" role="status">
                <span class="sr-only">Loading...</span>
              </div>
            </div>
          </div>
        </div>:
        <div className="container">
        <div className="row">
          <div className="col-lg-4 col-md-4">
            <div className="sidebar-left pr-4">

              <aside className="widget widget-recent-entries-custom">
                <div className="widget-title">
                  <h6>Recent Posts</h6>
                </div>
                <ul>
                  {
                    posts.map( (post,i) =>{
                      if(i<3){
                        return (
                          <li className="clearfix">
                            <div className="wi">
                              <Link onClick={ () => set_post_redux(post.fields.date,post.fields.title,post.sys.id) } title={`${post.fields.title}`}>
                                <img
                                  src={post.fields.thumbnail.fields.file.url || "img/blog/1.jpg"}
                                  alt="recent post"
                                  className="img-fluid rounded"
                                />
                              </Link>
                            </div>
                            <div className="wb">
                              <Link onClick={ () => set_post_redux(post.fields.date,post.fields.title,post.sys.id) } title={`${post.fields.title}`} >
                                {post.fields.title}
                              </Link>
                              <span className="post-date">{format(new Date(post.fields.date),'MMM dd yyyy')}</span>
                            </div>
                          </li>
                        )
                      }
                    })
                  }
                </ul>
              </aside>

              <aside className="widget widget-categories">
                <div className="widget-title">
                  <h6>Newsletter</h6>
                </div>
                <p>
                  Enter your email address below to subscribe to my
                  newsletter
                </p>
                <form
                  action="#"
                  method="post"
                  className="d-none d-md-block d-lg-block"
                  onChange={ (e) => SetSubscribeEmial(e.target.value) }
                  onSubmit={ e => handleSubcribe(e) }
                >
                  <input
                    type="text"
                    className="form-control input"
                    id="email-footer"
                    name="email"
                    placeholder="info@yourdomain.com"
                    value={subcribeEmail}
                  />
                  <button
                    type="submit"
                    className="btn solid-btn btn-block btn-not-rounded mt-3"
                    disabled={disableBtn}
                  >
                    Subscribe
                  </button>
                </form>
                { emailSubmitted ? <span class="badge badge-pill badge-success ml-3 badgeNewsLetter position-static">Enviado!</span>:null}
                { validationErrorMessage !== "" ? validationErrorMessage : null}
              </aside>
              <aside className="widget widget-tag-cloud">
                <div className="widget-title">
                  <h6>Tags</h6>
                </div>
                <div className="tag-cloud">
                  {
                    post.fields !== undefined ? 
                      post.fields.tags.map( tag =>(
                        <a href="/#">{tag}</a>
                      )) : null
                  }
                </div>
              </aside>
            </div>
          </div>
          {
            post.fields ?
              <div className="col-lg-8 col-md-8">
                <article className="post">
                  <div className="post-preview">
                    <a href="#">
                      <img src={(post.fields.cover.fields.file.url) || `${process.env.PUBLIC_URL}/img/blog/2-w.jpg` } alt="blog" />
                    </a>
                  </div>
                  <div className="post-wrapper">
                    <div className="post-header">
                      <h2 className="post-title">
                        <a href="#">
                        {(post.fields.title)}
                        </a>
                      </h2>
                      <ul className="post-meta">
                        <li>{format( new Date(post.fields.date),'MMM dd yyyy')}</li>
                        <li>
                          {
                            post.fields.tags.map( tag =>(
                              <a className="mx-2" href="/#">{tag}</a>
                            ))
                          }
                        </li>
                      </ul>
                    </div>
                    <div className="post-content">
                      <p>
                        {documentToReactComponents(post.fields.longDescription)}
                      </p>
                    </div>
                  </div>
                </article>
              </div>
            :
            <div className="col-lg-8 col-md-8">
              <article className="job">
                  <div className="job-wrapper">
                      <div className="job-header">
                          <p className="job-title w-50 mx-auto">Ops! no hay blog a mostrar</p>
                      </div>
                  </div>
              </article>
            </div>
          }
        </div>
      </div>
      }
      </div>
    </React.Fragment>
  );
}
 
export default Blog;
